import { lmsFetchAPI } from "../../../../utils/axios";

const ASSIGNMENTS_PATH = "/lms/assignments";

const toApiError = (error, fallback) => {
    const status = error?.response?.status;
    const message = error?.response?.data?.error || fallback;
    return { status, message };
};

export const getAssignments = async ({ studentId } = {}) => {
    try {
        const params = studentId ? { studentId } : undefined;
        const response = await lmsFetchAPI.get(ASSIGNMENTS_PATH, { params });
        return response.data;
    } catch (error) {
        throw toApiError(error, "Unable to load assignments");
    }
};

export const createAssignment = async (payload) => {
    try {
        const response = await lmsFetchAPI.post(ASSIGNMENTS_PATH, payload);
        return response.data;
    } catch (error) {
        throw toApiError(error, "Unable to create assignment");
    }
};
